(function() {
  'use strict';

  const helpGroups = window.__optionHelpGroups;
  if (!helpGroups || !helpGroups.length) return;

  // Build a lookup map: lowercase option title -> drawer id
  const titleToDrawer = {};
  helpGroups.forEach(function(g) {
    titleToDrawer[g.optionTitle.toLowerCase()] = g.drawerId;
  });

  // Convert <h3> elements inside help content into accordion items
  function convertToAccordion() {
    document.querySelectorAll('.option-help-content').forEach(function(container) {
      const children = Array.from(container.childNodes);
      const sections = [];
      let current = null;

      children.forEach(function(node) {
        if (node.nodeType === 1 && node.tagName === 'H3') {
          if (current) sections.push(current);
          current = { title: node.textContent.trim(), nodes: [] };
        } else if (current) {
          current.nodes.push(node);
        } else {
          // Content before any h3 — keep as-is
          sections.push({ title: null, nodes: [node] });
        }
      });
      if (current) sections.push(current);

      // Only convert if there's at least one h3
      const hasAccordion = sections.some(function(s) { return s.title !== null; });
      if (!hasAccordion) return;

      container.innerHTML = '';

      sections.forEach(function(section) {
        if (section.title === null) {
          // Non-accordion content (before first h3)
          var wrapper = document.createElement('div');
          section.nodes.forEach(function(n) { wrapper.appendChild(n.cloneNode(true)); });
          container.appendChild(wrapper);
          return;
        }

        var collapse = document.createElement('smooth-collapse');
        collapse.classList.add('option-help-collapse');
        collapse.style.display = 'block';

        var details = document.createElement('details');
        var summary = document.createElement('summary');
        summary.innerHTML =
          '<div class="font-accordion option-help-accordion-title">' +
          section.title +
          '</div>' +
          '<svg class="icon icon-chevron" width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
          '</svg>';

        details.appendChild(summary);

        var content = document.createElement('div');
        content.className = 'prose max-w-none pt-4';
        section.nodes.forEach(function(n) { content.appendChild(n.cloneNode(true)); });
        details.appendChild(content);

        collapse.appendChild(details);
        container.appendChild(collapse);
      });

      // Add border-bottom between collapse items (not on last)
      var collapses = container.querySelectorAll('.option-help-collapse');
      for (var i = 0; i < collapses.length - 1; i++) {
        collapses[i].style.borderBottom = '1px solid #e5e5e5';
      }
    });
  }

  // Create the "?" help icon button paired with a "Click here to learn more" hint
  function createHelpIcon(drawerId) {
    function openDrawer(e) {
      e.preventDefault();
      e.stopPropagation();
      var drawer = document.getElementById(drawerId);
      if (drawer && drawer.show) {
        drawer.show();
      } else if (drawer) {
        // Fallback: dispatch click on a modal-trigger targeting this drawer
        drawer.removeAttribute('hidden');
        drawer.setAttribute('open', '');
      }
    }

    var wrapper = document.createElement('span');
    wrapper.className = 'option-help';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'option-help-icon';
    btn.setAttribute('aria-label', 'Help');
    btn.textContent = '?';
    btn.addEventListener('click', openDrawer);

    var hint = document.createElement('button');
    hint.type = 'button';
    hint.className = 'option-help-hint';
    hint.textContent = 'Click here to learn more';
    hint.addEventListener('click', openDrawer);

    wrapper.appendChild(hint);
    wrapper.appendChild(btn);
    return wrapper;
  }

  // Inject "?" icons into ymq-option-title elements
  function injectHelpIcons() {
    var optionBoxes = document.querySelectorAll('.ymq-options-box[ymq-option-label]');
    optionBoxes.forEach(function(box) {
      // Skip if already injected
      if (box.querySelector('.option-help-icon')) return;

      var label = (box.getAttribute('ymq-option-label') || '').toLowerCase();
      var drawerId = titleToDrawer[label];
      if (!drawerId) return;

      var titleWrapper = box.querySelector('.ymq-option-title-wrapper');
      if (!titleWrapper) return;

      var labelEl = titleWrapper.querySelector('.ymq_lable');
      if (!labelEl) return;

      var icon = createHelpIcon(drawerId);
      labelEl.after(icon);
    });
  }

  // Watch for YMQ options to load (they render asynchronously)
  function watchForYmqOptions() {
    // Try immediately
    injectHelpIcons();

    // Use MutationObserver to detect when YMQ renders
    var container = document.querySelector('#product-detail-vue') || document.body;
    var observer = new MutationObserver(function(mutations) {
      var hasNewOptions = mutations.some(function(m) {
        return Array.from(m.addedNodes).some(function(node) {
          return node.nodeType === 1 && (
            node.tagName === 'YMQ-OPTION' ||
            node.classList && node.classList.contains('ymq-options-box') ||
            node.querySelector && node.querySelector('.ymq-options-box[ymq-option-label]')
          );
        });
      });
      if (hasNewOptions) {
        injectHelpIcons();
      }
    });

    observer.observe(container, { childList: true, subtree: true });

    // Also poll as fallback (YMQ might already be loaded)
    var attempts = 0;
    var poll = setInterval(function() {
      attempts++;
      injectHelpIcons();
      if (attempts > 20 || document.querySelectorAll('.option-help-icon').length >= Object.keys(titleToDrawer).length) {
        clearInterval(poll);
      }
    }, 500);
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      convertToAccordion();
      watchForYmqOptions();
    });
  } else {
    convertToAccordion();
    watchForYmqOptions();
  }
})();
